import { SectionContent } from 'app/views/presentations/models/sectionContent.model';

export enum VideoDisplayModeType {
  Full = 'Full',
  Restrict = 'Restrict'
}

export class VideoModel extends SectionContent {
    constructor(
        public displayMode?: VideoDisplayModeType
    ) {
        super();
    }
}



// WEBPACK FOOTER //
// ./src/app/views/presentations/models/video.model.ts